/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import {
  notificationSetting,
  notificationType,
  showNotification,
} from "../Common";
import { connectWallet } from "../Scripts/interact";
import useWalletChange from "../hooks/useWalletChange";

const BabyMintHeader = () => {
  const { isWalletConnected, changedAddress } = useWalletChange();

  const connectWalletPressed = async () => {
    const response = await connectWallet();

    if (response.status) {
      console.log("Wallet Connected");
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  return (
    <>
      <div className="banner-sec">
        <div className="container">
          <div className="in-pg-content text-center">
            <h2>Super Creators - Divine Fusion Chamber</h2>
            {isWalletConnected ? (
              <>
                <div className="open-sea-btn">
                  <p>
                    WALLET: <span>{changedAddress}</span>
                  </p>
                  <a
                    href={"https://opensea.io/collection/super-creators-gen-z"}
                    target="_blank"
                    rel="noreferrer"
                    className="btn"
                  >
                    Super Creators - Gen Z Collection on Opensea
                  </a>
                </div>
              </>
            ) : (
              // <button className="btn btn-large" disabled>
              //   Wallet Address:{" "}
              //   {`${changedAddress?.substring(
              //     0,
              //     5
              //   )}...${changedAddress?.substring(
              //     changedAddress?.length - 4,
              //     changedAddress?.length
              //   )}`}
              // </button>
              <>
                <button
                  className="btn btn-large"
                  onClick={connectWalletPressed}
                >
                  CONNECT WALLET
                </button>
                {/* <p>
                  Connect Your Wallet to Access Super Creators Token Holder
                  Benefits
                </p> */}
              </>
            )}

            {/* <h2>What Would you like to Manifest</h2>
              <div>
                <button className="btn btn-large yellow-active" onClick={connectWalletPressed}>
                  Baby Super Creator
                </button>
                <button className="btn btn-large" onClick={connectWalletPressed}>
                  Legendary Super Creator
                </button>
              </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default BabyMintHeader;
